/**
 * Hesap açmadan e-posta oturumları (magic link).
 * - tracking: lider / bölüm yöneticisi → opex-takip
 * - opex: config opexUsers → opex-filtre (ve OPEX görünümü)
 */

const TRACKING_STORAGE_KEY = 'odul-opex-tracking-session-v1'
const OPEX_STORAGE_KEY = 'odul-opex-filtre-session-v1'
/** Oturum süresi (claim sonrası tarayıcıda) */
export const TRACKING_SESSION_DAYS = 14
/** Magic link geçerlilik */
export const TRACKING_ACCESS_LINK_HOURS = 48

export const TRACKING_ACCESS_ROLE = 'tracking_access'
export const OPEX_ACCESS_ROLE = 'opex_access'

const normalizeEmail = (value) => String(value || '').trim().toLowerCase()

const createAccessTokenPayload = (email, role, recordNumberTag) => {
  const normalized = normalizeEmail(email)
  if (!normalized || !normalized.includes('@')) {
    throw new Error('Geçerli bir e-posta girin.')
  }
  const randomBytes = new Uint8Array(32)
  window.crypto.getRandomValues(randomBytes)
  const tokenId = Array.from(randomBytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
  const createdAt = new Date()
  const expiresAt = new Date(
    createdAt.getTime() + TRACKING_ACCESS_LINK_HOURS * 60 * 60 * 1000
  )
  return {
    tokenId,
    role,
    email: normalized,
    recordNumber: recordNumberTag,
    assigneeId: normalized,
    createdAt: createdAt.toISOString(),
    expiresAt: expiresAt.toISOString(),
    isUsed: false,
    usedAt: null,
  }
}

export const createTrackingAccessTokenPayload = (email) =>
  createAccessTokenPayload(email, TRACKING_ACCESS_ROLE, 'TRACKING')

export const createOpexAccessTokenPayload = (email) =>
  createAccessTokenPayload(email, OPEX_ACCESS_ROLE, 'OPEX')

const readSession = (storageKey) => {
  try {
    const raw = localStorage.getItem(storageKey)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    const email = normalizeEmail(parsed?.email)
    if (!email) return null
    if (parsed.expiresAt && new Date(parsed.expiresAt).getTime() < Date.now()) {
      localStorage.removeItem(storageKey)
      return null
    }
    return {
      email,
      claimedAt: parsed.claimedAt || null,
      expiresAt: parsed.expiresAt || null,
    }
  } catch {
    return null
  }
}

const writeSession = (storageKey, email) => {
  const normalized = normalizeEmail(email)
  if (!normalized) return null
  const claimedAt = new Date()
  const expiresAt = new Date(
    claimedAt.getTime() + TRACKING_SESSION_DAYS * 24 * 60 * 60 * 1000
  )
  const session = {
    email: normalized,
    claimedAt: claimedAt.toISOString(),
    expiresAt: expiresAt.toISOString(),
  }
  localStorage.setItem(storageKey, JSON.stringify(session))
  return session
}

export const readTrackingSession = () => readSession(TRACKING_STORAGE_KEY)
export const writeTrackingSession = (email) => writeSession(TRACKING_STORAGE_KEY, email)
export const clearTrackingSession = () => {
  localStorage.removeItem(TRACKING_STORAGE_KEY)
}

export const readOpexSession = () => readSession(OPEX_STORAGE_KEY)
export const writeOpexSession = (email) => writeSession(OPEX_STORAGE_KEY, email)
export const clearOpexSession = () => {
  localStorage.removeItem(OPEX_STORAGE_KEY)
}

/** Kayıt, e-posta için lider veya bölüm yöneticisi mi? */
export const emailMatchesImplementation = (email, impl, record) => {
  const e = normalizeEmail(email)
  if (!e) return false
  const leader = normalizeEmail(impl?.plan?.leaderEmail)
  const manager = normalizeEmail(
    record?.relatedDepartmentManagerEmail || record?.assignee?.email
  )
  return e === leader || e === manager
}
